/**
 * Returns a random number between min (inclusive) and max (exclusive)
 * @param {Number} min Minimal boundary for rand integer
 * @param {Number} max Maximal boundary for rand integer
 */
export default function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}
